import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = {
  id: "user-menu",
  class: "user-menu"
}
const _hoisted_2 = ["aria-label"]
const _hoisted_3 = {
  "uk-dropdown": "mode: click; pos: bottom-right",
  class: "user-menu-dropdown"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_user_info = _resolveComponent("user-info")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("button", {
      id: "user-menu-toggle",
      type: "button",
      class: "user-menu-icon",
      "aria-label": _ctx.$t('header.account'),
      "uk-icon": "icon: user"
    }, null, 8, _hoisted_2),
    _createElementVNode("div", _hoisted_3, [
      (_ctx.user)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
            _createVNode(_component_user_info, { user: _ctx.user }, null, 8, ["user"]),
            _cache[1] || (_cache[1] = _createElementVNode("hr", { class: "uk-margin-small" }, null, -1))
          ], 64))
        : _createCommentVNode("", true),
      _createElementVNode("button", {
        id: "user-menu-logout",
        type: "button",
        class: "uk-button uk-button-default uk-button-small uk-width-1-1",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('logout')))
      }, _toDisplayString(_ctx.$t('header.logout')), 1)
    ])
  ]))
}